export const FEATURE_FLAG_NAMES = {
  show_completed_jobs_on_dashboard: "show_completed_jobs_on_dashboard",
  enable_pocketflows: "enable_pocketflows",
  yard_sign_photo_spiff: "yard_sign_photo_spiff",
  enable_icm_reruns: "enable_icm_reruns",
  show_payroll_emails: "show_payroll_emails",
  enable_payroll_emails: "enable_payroll_emails",
  enable_payroll_roster: "enable_payroll_roster",
  enable_pay_plan: "enable_pay_plan",
  enable_st_adjustments: "enable_st_adjustments",
} as const;
